import { render, staticRenderFns } from "./ComplianceSubcategoryExternal.vue?vue&type=template&id=73589475"
import script from "./ComplianceSubcategoryExternal.vue?vue&type=script&lang=js"
export * from "./ComplianceSubcategoryExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports